import axios from "axios";
import { FinalizePackageRequest, FinalizePackageResponse } from "redmond";
import { config } from "../../config";

import { flightLodgingFinalizeApiPrefix } from "../paths";

export const finalizeFlightLodging = (
  body: FinalizePackageRequest
): Promise<FinalizePackageResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(flightLodgingFinalizeApiPrefix, body, {
        baseURL: config.baseURL,
      });

      if (res.data.Response === "Success") {
        resolve(res.data.value);
      } else {
        reject(res.data.error);
      }
    } catch (e) {
      reject(e);
    }
  });
